<template>
	<div>
		
		
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">

			<el-form-item label="图片:" prop="img_url">
				<el-upload class="avatar-uploader" :action="this.$http_host + '/Admin/Upload/uploadImage'" :headers="headers" :show-file-list="false"
					:on-success="UploadSuccess"
					:before-upload="beforeUpload"
					:on-error="UploadError"
				>
				  <img v-if="ruleForm.img_url" :src="this.$http_host + ruleForm.img_url" class="avatar">
				  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
			</el-form-item>
			
			<el-form-item label="" prop="">
				<div style="color:red;">banner比例：140x100为比例</div>
			</el-form-item>
				
			<el-form-item label="跳转方式:" prop="types">
				<el-select v-model="ruleForm.types">
					<el-option value="none" label="不跳转"></el-option>
					<el-option value="app" label="内页跳转"></el-option>
				</el-select>
			</el-form-item>
			
			<el-form-item label="参数:" prop="param">
				<el-input size="small" v-model="ruleForm.param"></el-input>
			</el-form-item>
				
			<el-form-item label="备注:" prop="remarks">
				<el-input size="small" v-model="ruleForm.remarks"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="submitForm('ruleForm')">立即添加</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	export default {
	    data() {
			return {
				
				ruleForm: {
					img_url: '',
					types:'',
					param:'',
					remarks: ''
				},
				rules: {
					img_url: [{required: true, message: '请上传图片', trigger: 'blur'}],
					types: [{required: true, message: '请选择跳转类型', trigger: 'blur'}],
					param: [{required: true, message: '请输入参数，不跳转输入#', trigger: 'blur'}],
					remarks: [{required: true, message: '请输入备注信息', trigger: 'blur'}]
				},
				headers:{
					Authorization:'',
				}
	      };
	    },
		created() {
			this.headers.Authorization = localStorage.getItem('access_token');
		},
	    methods: {
			beforeUpload(file){
			},
			UploadSuccess(res, file, fileList){
				if(res.code == 200)
				{
					this.ruleForm.img_url = res.data.url;
				}else{
					return this.$message({ message: res.msg, type: 'warning' });
				}
			},
			UploadError(){
				return this.$message({ message: '上传失败，请重试', type: 'warning' });
			},
			submitApi(){
				let _this = this;
				const loading = this.$loading({
						lock: true,
						text: '添加中',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				_this.$api.post("/Set/addBanner", this.ruleForm).then(res=>{
					loading.close();
					if(res.code == 200)
					{
						_this.$message({
							 message: '添加成功~',
							 type: 'success',
						});
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			},
			submitForm(formName) {
				let _this = this;
				this.$refs[formName].validate((valid) => {
					if (valid) {
						_this.submitApi();
					} else {
						return _this.$message({
							 message: '提交失败',
							 type: 'warning',
						});
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			}
	    }
	  }
</script>

<style scoped>
	.avatar-uploader .el-upload {
	    border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	  }
	  .avatar-uploader .el-upload:hover {
	    border-color: #409EFF;
	  }
	  .avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    min-width: 280px;
	    height: 200px;
	    line-height: 200px;
	    text-align: center;
		border:dashed 1px #dcdcdc;
	  }
	  .avatar {
	    min-width: 280px;
	    height: 200px;
	    display: block;
	  }
</style>